<template>
  <div>
    <!--Subscribed Plan-->
    <div v-if="subscription.status === 'active'" class="subscriber-wrapper">
      <SubscribedMeteredPlan
        :content="subscribedPlan.content"
        :plan="subscribedPlan.plan"
        :chargebeeSubscription="chargebeeSubscription"
      ></SubscribedMeteredPlan>
    </div>

    <!-- Key Analytics -->
    <div v-if="!fetchingAnalytics">
      <div class="metrics-wrapper">
        <h3 class="metrics-title">Monthly Metrics</h3>
        <KeyMetrics :stats="analytics?.keyMetrics"></KeyMetrics>
      </div>
    </div>

    <!--Pre Loader-->
    <PreLoader v-else :show="true" class="main-content"></PreLoader>
  </div>
</template>

<script>
// Libraries
import _ from "lodash";

// Components
import KeyMetrics from "@/components/dashboard/analytics/KeyMetrics";
import PreLoader from "@/components/loaders/PreLoader";
import SubscribedMeteredPlan from "@/components/dashboard/subscription/meteredPlans/SubscribedPlan";

// Services
// Services
import { TranslationsAppService } from "@/services";
const { CompanyService, AnalyticsService } = TranslationsAppService;

export default {
  name: "ActiveCustomer",
  data() {
    return {
      lodash: _,
      showOptions: {
        headerShadow: false,
        unsavedChanges: false,
        lineLoader: false,
        disableButton: true,
      },
      fetchingAnalytics: true,
      analytics: {},
      chargebeeSubscription: {},
      subscribedPlan: {
        content: {
          title: "Subscription",
          description: "Manage your plan and licenses",
        },
        plan: {
          title: "Business Plan",
          description: "The best AI ticket translations on Zendesk",
          unit: "license",
        },
      },

      status: {
        show: false,
        status: "success",
        title: "Widget theme saved",
      },
    };
  },
  props: {},
  components: {
    KeyMetrics,
    SubscribedMeteredPlan,
    PreLoader,
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    selectedApp() {
      return this.$store.getters.selectedApp;
    },
    subscription() {
      return this.selectedApp.subscription;
    },
  },
  watch: {},
  async created() {
    this.getAnalytics();
    this.getSubscription();
  },
  methods: {
    // Get subscription details from Chargebee
    async getSubscription() {
      const data = { companyId: this.company._id };
      const response = await CompanyService.GetChargebeeSubscription(data);

      if (!response.hasError) {
        this.chargebeeSubscription = response.data.subscription;
      }
    },

    // Get insights
    async getAnalytics() {
      this.fetchingAnalytics = true;

      const payload = this.constructPayload();
      const response = await AnalyticsService.GetAnalytics(payload);
      if (!response.hasError) this.analytics = response.data;

      this.fetchingAnalytics = false;
    },

    constructPayload() {
      const currentDate = new Date();
      const currentDateUTC = new Date(
        Date.UTC(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), 1)
      );

      const fmt = new Intl.DateTimeFormat("en-US", {
        month: "short",
        year: "numeric",
        timeZone: "UTC",
      });

      const data = {
        companyId: this.company._id,
        date: fmt.format(currentDateUTC),
      };

      return data;
    },
  },
};
</script>

<style scoped lang="scss">
.subscriber-wrapper ::v-deep {
  margin-bottom: 2rem;

  .info-wrapper,
  .btn {
    display: none;
  }

  .term-details {
    text-align: right;
  }

  .active-plan {
    max-width: 40rem;
  }
}

.metrics-title {
  font-size: 1.15rem;
  margin-bottom: 2rem;
}

.metrics-wrapper {
  margin: 3rem 0;

  ::v-deep .stat-item {
    text-align: left;

    .stat-label {
      justify-content: flex-start;
    }
  }
}
</style>
